import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path1/node_modules/@babel/runtime/regenerator/index.js";
import Toast from "../components/Toast";
import servicesUtils from "./servicesUtils";
import { getFCMToken, getPlatform, isAndroidWebView, isIOSWebView } from ".";
import Store from "./Store";
import constants from "./constants";
import { t } from "i18next";
export var registerSubscription = function registerSubscription(token) {
  var params = {
    token: token,
    platform: getPlatform()
  };
  return servicesUtils.postService("/subscription/", params).then(function () {
    return true;
  })["catch"](function () {
    Toast.error(t("unable_to_subscribe"));
    return false;
  });
};
export var unRegisterSubscription = function unRegisterSubscription(token) {
  var params = {
    token: token
  };
  return servicesUtils.postService("/subscription/delete/", params);
};
export var subscribeUserNotification = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(RNFcmToken) {
    var token, _window, status, _window2, old_fcmToken, _window3, isSuccess, _window4;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          token = RNFcmToken || null;
          if (!(!token && !isAndroidWebView() && !isIOSWebView())) {
            _context.next = 13;
            break;
          }
          _context.next = 5;
          return (_window = window) === null || _window === void 0 || (_window = _window.Notification) === null || _window === void 0 ? void 0 : _window.requestPermission();
        case 5:
          status = _context.sent;
          if (!(status && status === "granted")) {
            _context.next = 12;
            break;
          }
          _context.next = 9;
          return getFCMToken();
        case 9:
          token = _context.sent;
          _context.next = 13;
          break;
        case 12:
          if (status && status === "denied") {
            Toast.error(t("allow_browser_permission"));
          }
        case 13:
          if (!token) {
            _context.next = 22;
            break;
          }
          old_fcmToken = (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.localStorage.getItem(constants.PERSISTED.fcmToken);
          if (old_fcmToken && token != old_fcmToken) {
            unRegisterSubscription(old_fcmToken);
            (_window3 = window) === null || _window3 === void 0 || _window3.localStorage.removeItem(constants.PERSISTED.fcmToken);
          }
          _context.next = 18;
          return registerSubscription(token);
        case 18:
          isSuccess = _context.sent;
          if (isSuccess) {
            (_window4 = window) === null || _window4 === void 0 || _window4.localStorage.setItem(constants.PERSISTED.fcmToken, token);
          }
          if (isSuccess && !RNFcmToken) {
            Store.update(function (s) {
              s.fcmToken = token;
            });
          }
          return _context.abrupt("return", isSuccess);
        case 22:
          return _context.abrupt("return", null);
        case 25:
          _context.prev = 25;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);
          return _context.abrupt("return", null);
        case 29:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 25]]);
  }));
  return function subscribeUserNotification(_x) {
    return _ref.apply(this, arguments);
  };
}();